import { useTranslation } from "@l2r-front/l2r-i18n"
import { PropTypes } from "@l2r-front/l2r-proptypes"
import { undefinedFunctionWarning } from "@l2r-front/l2r-utils"

import { I18N_NAMESPACE } from "../../constants/i18n"

import { BottomSheet } from "../BottomSheet"

import * as Styled from "./FilterBottomSheet.styled"

export const FilterBottomSheet = (props) => {
    const {
        children,
        title,
        ...bottomSheetProps
    } = props

    const { t } = useTranslation(I18N_NAMESPACE)

    return <BottomSheet {...bottomSheetProps}
        disableDiscovery
        disableBackdropTransition
        disableSwipeToOpen
        disableEnforceFocus >
        <Styled.ContentWrapper>
            <Styled.Title variant="H2">{title || t(I18N_NAMESPACE, "components.filterBottomSheet.title")}</Styled.Title>
            {children}
        </Styled.ContentWrapper>
    </BottomSheet>
}

FilterBottomSheet.propTypes = BottomSheet.propTypes & {
    title: PropTypes.string,
}

FilterBottomSheet.defaultProps = {
    onOpen: undefinedFunctionWarning("onOpen"),
}